module.exports = __webpack_public_path__ + "article-7051a3ee/arbeitsvertrag-93d9c9007d593377289be25593fdf4fd.jpeg";